// extracted by mini-css-extract-plugin
export default {"reviewsBox":"comment_reviewsBox__78MV-","reviewsBoxImg":"comment_reviewsBoxImg__bj7dn"};